var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 col-lg-8 col-xl-6 mx-auto pt-3"},[_c('h1',{staticClass:"text-center pb-3"},[_vm._v("Login")]),_vm._v(" "),_c('login-form',{on:{"loginSuccess":_vm.onLoginSuccess}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ba1db12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/-service-app/pages/auth/LoginPage.vue
// module id = null
// module chunks = 